import React from 'react';
import PropTypes from 'prop-types';

import { Group } from '@vx/group';
import { LinePath, Area } from '@vx/shape';

const x = d => d.date;

// Median price
const y = d => d.medianPrice;

// HDI
const y0 = (p, d) => d[`hdi${p}`].up;
const y1 = (p, d) => d[`hdi${p}`].down;

const MedianPrice = ({ data, margin, xScale, yScale }) => (
  <Group top={margin.top} left={margin.left}>
    <Area
      data={data}
      x={d => xScale(x(d))}
      y0={d => yScale(y0(70, d))}
      y1={d => yScale(y1(70, d))}
      fill="rgba(254, 123, 35, .3)"
    />
    <Area
      data={data}
      x={d => xScale(x(d))}
      y0={d => yScale(y0(30, d))}
      y1={d => yScale(y1(30, d))}
      fill="rgba(254, 123, 35, .4)"
    />
    <LinePath
      data={data}
      x={d => xScale(x(d))}
      y={d => yScale(y(d))}
      stroke="rgb(254, 123, 35)"
      strokeWidth={2}
    />
  </Group>
);

MedianPrice.propTypes = {
  margin: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }),
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.object,
      medianPrice: PropTypes.number,
      hdi30: PropTypes.shape({ up: PropTypes.number, down: PropTypes.number }),
      hdi70: PropTypes.shape({ up: PropTypes.number, down: PropTypes.number }),
    })
  ).isRequired,
};

MedianPrice.defaultProps = {
  margin: { top: 0, left: 0 },
};

export default MedianPrice;
